module.exports = __webpack_public_path__ + "img/badge-list-thumb-086.1e1caad3.png";